module.exports = __webpack_public_path__ + "img/meet.1b59c77e.svg";